import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js';
import Counter from '../../../NumCounter.js';
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Deafness Management in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get expert deafness management in Delhi, India. Learn about causes, treatment options, therapy, and cost at top ENT and audiology clinics." />
            <meta name="keywords" content="deafness care Delhi, hearing loss solution, ENT deafness treatment, audiology Delhi,
Top Deafness ENT Specialist in Delhi,Best Doctors For Hearing Loss Remedies Treatmen" />
            <link rel="canonical" href="https://entdelhi.com/deafness-management/" />
            <meta property="og:title" content="Deafness Management in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get expert deafness management in Delhi, India. Learn about causes, treatment options, therapy, and cost at top ENT and audiology clinics." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />  
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
